import { useState } from 'react';

import { AddAccount } from '@/features/account-actions';

import {
  CurrencyAccountItem,
  useVabsAccountsStore,
} from '@/entities/currency-account';

import { X } from '@/shared/assets';
import { ICurrencyAccount } from '@/shared/lib';
import { Button, DashboardDialogProps, Header, Typography } from '@/shared/ui';

import { MoneyFlowType } from '../../../../model/types';
import { useSendMoney } from '../../../../model/useSendMoney';

const AccountsContent: React.FC<{
  setStep: (step: MoneyFlowType) => void;
  onClose?: () => void;
}> = ({ setStep, onClose }) => {
  const [isAddAccountOpen, setIsAddAccountOpen] = useState(false);
  const accounts = useVabsAccountsStore((state) => state.accounts);
  const data = useSendMoney((state) => state.data);
  const updateFormData = useSendMoney((state) => state.updateFormData);
  const updateSendStep = useSendMoney((state) => state.setStep);
  const filteredItems = accounts
    ? accounts.filter(
        (item) =>
          item.status === 'ACTIVE' &&
          data?.innerAvailableCurrencies?.includes(item.currencyId),
      )
    : [];
  const inactiveItems = accounts
    ? accounts.filter(
        (item) =>
          item.status === 'ACTIVE' &&
          !data?.innerAvailableCurrencies?.includes(item.currencyId),
      )
    : [];

  const onSelect = (account: ICurrencyAccount) => {
    updateFormData({ account });
    updateSendStep('amount');
    setStep('send-inner');
  };
  return (
    <div className="flex h-full flex-1 flex-col">
      <div className="flex-1 px-4">
        {filteredItems.map((item, idx) => (
          <CurrencyAccountItem
            item={item}
            onClick={onSelect}
            disabled={item.status !== 'ACTIVE'}
            isSelected={data?.account?.id === item.id}
            key={item.id}
          />
        ))}
        {inactiveItems.map((item, idx) => (
          <CurrencyAccountItem
            item={item}
            disabled
            onClick={() => void 0}
            key={item.id}
            isSend
            description="Can't receive"
          />
        ))}
      </div>

      <div className="my-3 flex w-full items-center justify-center gap-1">
        <Typography variant="13-r" color="text-base-100">
          Currency not listed?
        </Typography>
        <Button
          variant="clean"
          onClick={() => {
            setIsAddAccountOpen(true);
          }}
        >
          <Typography variant="13-r" color="brand-500">
            Request new currency
          </Typography>
        </Button>
      </div>

      <AddAccount
        open={isAddAccountOpen}
        onOpenChange={setIsAddAccountOpen}
        onConfirmAdding={() => {
          setIsAddAccountOpen(false);
          onClose?.();
        }}
      >
        <></>
      </AddAccount>
    </div>
  );
};

interface AccountsProps {
  setStep: (step: MoneyFlowType) => void;
  onBack: () => void;
  isFirst: boolean;
  onClose?: () => void;
}

export const accountsProps = ({
  setStep,
  onBack,
  isFirst,
  onClose,
}: AccountsProps): DashboardDialogProps => {
  return {
    header: (
      <Header
        className="z-50 p-5"
        title="Choose currency"
        action={{
          as: 'custom',
          render: (
            <Button
              variant="dark-secondary"
              size="rounded-sm"
              onClick={() => {
                setStep('find-client');
              }}
            >
              <X className="text-base-500" />
            </Button>
          ),
        }}
      />
    ),
    hideCloseButton: true,
    content: <AccountsContent setStep={setStep} onClose={onClose} />,
    animationProps: {
      id: 'choose',
      isFirst: isFirst,
    },
    disableOutsideClick: !isFirst,
    closeButtonProps: {
      onClick: () => {
        setStep('find-client');
      },
    },
  };
};
